// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface DynamicSearchWidthReducerState {
    searchWidth: number;
    loggedInExtraWidth: number;
}

const initialState: DynamicSearchWidthReducerState = {
    searchWidth: 0,
    loggedInExtraWidth: 0,
};
const extraSpacing = 60;
const reducer = {
    "Pages/Header/SetSearchWidth": (
        draft: Draft<DynamicSearchWidthReducerState>,
        action: { primaryWidth: number; loggedInOffset: number },
    ) => {
        draft.searchWidth = action.primaryWidth - extraSpacing;
        draft.loggedInExtraWidth = action.loggedInOffset;
    },
};

const dynamicSearchWidthReducer = createTypedReducerWithImmer(initialState, reducer);
export type DynamicSearchWidthActions = Parameters<typeof dynamicSearchWidthReducer>[1];
export default dynamicSearchWidthReducer;
